import { render, staticRenderFns } from "./torrentSettings.vue?vue&type=template&id=8cebb130&scoped=true&"
import script from "./torrentSettings.vue?vue&type=script&lang=js&"
export * from "./torrentSettings.vue?vue&type=script&lang=js&"
import style0 from "./torrentSettings.vue?vue&type=style&index=0&id=8cebb130&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cebb130",
  null
  
)

export default component.exports